import React from 'react';

import noop from 'lodash/noop';

import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';


const GridTileWrapperUiBase = ({
  actionTypeName,
  className,
  col,
  contentId,
  children,
  dataTileAspectReducedAttr,
  hasFileIcon,
  horizontalAlign,
  itemType,
  outerTileWrapperStyle,
  row,
  shouldShowHover,
  sizex,
  sizey,
  tellRef,
  uuid,
  verticalAlign,
  shouldMaintainStackOrder,
  onClick,
  onMouseEnter,
  onMouseLeave
})=> (
  <div 
    ref={tellRef}
    onClick={onClick}
    id={'uuid-' + uuid} 
    className={className}
    data-scroll-to-content-uuid={uuid}
    data-should-show-hover={shouldShowHover ? 'true' : 'false'}
    data-row={row}
    data-col={col}
    data-sizex={sizex}
    data-sizey={sizey}
    content_id={contentId}
    tile_type={itemType}
    action_type={actionTypeName}
    content_uuid={uuid}
    // unfortunately, because of legacy themes, 
    // the HTML attribute that indicates a file icon is "pdf_icon" instead of "file_icon"
    pdf_icon={'' + hasFileIcon} // we want to cast true and false to be a string here
    vertical_align={verticalAlign} // we expect this to be undefined if it does not have a value
    horizontal_align={horizontalAlign} // we expect this to be undefined if it does not have a value
    data-tile-aspect-reduced={dataTileAspectReducedAttr}
    should-maintain-stack-order={
      (
         shouldMaintainStackOrder
      ) ?
        'true'
      :
        'false'
    }
    style={outerTileWrapperStyle}
    onMouseEnter={onMouseEnter ? onMouseEnter : noop}
    onMouseLeave={onMouseLeave ? onMouseLeave : noop}
  >
    { children }
  </div>
);

const GridTileWrapperUi_ViewerVersion1 = (props)=> (
  <GridTileWrapperUiBase 
    onClick={(e)=>{ 
      getTracker().handleTileClick(e);

      if (props.actionTypeName === 'overlay') {
        e.preventDefault();
        props.onOverlayOpen();
      }
    }}
    {...props}
  />
);

// clicks are handled inside the tile in accessible sites
const GridTileWrapperUi_ViewerVersion2 = (props)=>
  <GridTileWrapperUiBase onClick={noop} {...props} />;

const GridTileWrapperUi = (props)=> (
  <SiteViewerVersionComponentSelector>
    <GridTileWrapperUi_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <GridTileWrapperUi_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default GridTileWrapperUi;
